import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSortModule } from '@angular/material/sort';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoNavigationModule } from 'tsui/@treo';
import { TreoScrollbarModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { TreoDrawerModule } from 'tsui/@treo';
import { FormsModule } from '@angular/forms';
import { TreoCardModule } from 'tsui/@treo';
import { TreoDateRangeModule } from 'tsui/@treo';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import {
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatLegacyAutocompleteModule as MatAutocompleteModule,
} from '@angular/material/legacy-autocomplete';
import { Overlay } from '@angular/cdk/overlay';
import { CalculatorModule } from 'app/layout/common/calculator/calculator.module';
import { projectsRoutes } from './projects.routing';
import { SharedResourcesProjectsComponent } from './projects.component';
import { SharedResourcesProjectDetailsComponent } from './details/details.component';
import { SharedResourcesProjectHeaderComponent } from './details/header/header.component';
import { MentionModule } from 'angular-mentions';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { environment } from '@env/environment';
import { PipelineService } from 'app/modules/projects/pipeline.service';

@NgModule({
  declarations: [
    SharedResourcesProjectsComponent,
    SharedResourcesProjectDetailsComponent,
    SharedResourcesProjectHeaderComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    RouterModule.forChild(projectsRoutes),
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatTabsModule,
    CurrencyMaskModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatMomentDateModule,
    MatPaginatorModule,
    TreoCardModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatRadioModule,
    MatRippleModule,
    MatSortModule,
    MatSelectModule,
    CalculatorModule,
    MatButtonToggleModule,
    MatSidenavModule,
    MatTableModule,
    MatTooltipModule,
    MatAutocompleteModule,
    TreoAutogrowModule,
    MatProgressSpinnerModule,
    TreoFindByKeyPipeModule,
    TreoNavigationModule,
    TreoScrollbarModule,
    TreoDateRangeModule,
    SharedModule,
    DragDropModule,
    FormsModule,
    TreoDrawerModule,
    MentionModule,
    MatCardModule,
    NgxMapboxGLModule.withConfig({ accessToken: environment.mapbox.accessToken }),
  ],
  providers: [
    PipelineService,
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class SharedResourcesProjectsModule {}
